import { GsFormIfArgValue, GsFormIfOperator } from 'libs/shared/src/components';

export function schemaDefaultCompare(arg: GsFormIfArgValue, value: unknown, operator: GsFormIfOperator) {
  if (!operator) operator = '==';
  switch (operator) {
    case '==': {
      return value == arg;
    }
    case '!=': {
      return value != arg;
    }
    case '<': {
      return Number(value ?? 0) < Number(arg ?? 0);
    }
    case '<=': {
      return Number(value ?? 0) <= Number(arg ?? 0);
    }
    case '>': {
      return Number(value ?? 0) > Number(arg ?? 0);
    }
    case '>=': {
      return Number(value ?? 0) >= Number(arg ?? 0);
    }
    default: {
      return false;
    }
  }
}
